import { Container } from "react-bootstrap";
import { Col, Row, Button } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import BackArrow from "../../../components/backArrow";
import { useRef } from "react";
import PersonalImage from "../../../helpers/fileUpload";
import { useState } from "react";
import { useEffect } from "react";
import Card from "react-bootstrap/Card";
import SearchIcon from "@mui/icons-material/Search";
import { images } from "../../../constants";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { Measurementunit, currencies } from "../../../constants/jsonConstant";
import ClearIcon from "@mui/icons-material/Clear";
import { useSelector } from "react-redux";
import Loader from "../../../components/Loader";
import { SuccessNotify, FailedNotify } from "../../../constants/tostify";
import { publishImage } from "../../../helpers/imageupload";
import { 
  useGetShopItemDetailQuery, 
  useUpdateShopItemMutation, 
  useLazyGetShopConsumerCategoriesQuery, 
  useLazyGetShopCategoriesQuery, 
  useGetWorldCitiesQuery 
} from "../../../features/shop/shopApiSlice";
import { useDropzone } from "react-dropzone";
import { getAsset } from "../../../helpers/helper";
const UpdateSingleAdd = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isloading, setIsloading] = useState(false);
  const { id } = useParams();
  const [shopCategory, setShopCategory] = useState()
  const [shopCategorytwo, setShopCategorytwo] = useState()
  const [displayimg, setDisplayimg] = useState();
  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  const imageUrl = useSelector((state) => state.imgurl);
  const { name } = useSelector((state) => state.user);
  const [selectedImage, setSelectedImage] = useState("");

  const [data, setData] = useState({
    category: ""
  })

  const Handledata = (e) => {
    setData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value.split(".")

    }))
  }
  const categoryName = data?.category[1];
  const categoryid = data.category[0];




  const onDrop = async (acceptedFiles) => {
    try {
      setIsUploading(true);
      setUploadProgress(0);

      const abc = await publishImage(acceptedFiles, (percent) => {
        setUploadProgress(percent);
      });
      setUserData((userData) => ({
        ...userData,
        images: abc
      }));

      setDisplayimg(abc);

    } catch (error) {
      FailedNotify("Failed! Try Again");
    } finally {
      setIsUploading(false);
      setUploadProgress(0);
    }
  }

  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*",
    onDrop,
  });

  const [userData, setUserData] = useState({
    userid: name._id,
    itemname: "",
    isSingleItem: true,
    isScrapeItem: false,
    category: categoryid,
    subCategory: "",
    price: "",
    country: "",
    city: "",
    state: "",
    quantity: "",
    description: "",
    unitOfMeasurement: "",
    currency: "",
    images: [""],
    status: true
  });


  useEffect(() => {
    setUserData((userData) => ({
      ...userData,
      category: categoryid

    }));

  }, [categoryid]);






  const [getShopConsumerCategories] = useLazyGetShopConsumerCategoriesQuery();
  const [getShopCategories] = useLazyGetShopCategoriesQuery();
  const [updateShopItem] = useUpdateShopItemMutation();

  const FirstCategory = async (e) => {
    e.preventDefault();
    try {
      const response = await getShopConsumerCategories({ type: 'singleItem', parentCategory: '' }).unwrap();
      if (response?.success) {
        setShopCategory(response?.data?.Category);
      }
    } catch (error) {
      console.log("servicesCategories", error);
    }
  };


  const InputChange = (e) => {

    setUserData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value

    }))
  }


  const Mydata = async (e) => {
    e.preventDefault();
    try {
      const response = await getShopCategories({ type: 'singleItem', parentCategory: categoryName }).unwrap();
      if (response?.success) {
        setShopCategorytwo(response?.data?.Category);
      }
    } catch (error) {
      console.log("servicesCategories", error);
    }
  };

  const userDatahandler = async (e) => {
    e.preventDefault();
    setIsloading(true);
    try {
      const response = await updateShopItem({ id, data: userData }).unwrap();
      console.log("newitemdata", response);
      if (response?.success) {
        setIsloading(false);
        setTimeout(() => {
          SuccessNotify("Add Updated Successfully");
        }, 1000);
        navigate(`/singleadd-show`);
      }
    } catch (error) {
      setIsloading(false);
      FailedNotify("Failed To Update Try Again!");
    }
  };

  const { data: itemDetailData } = useGetShopItemDetailQuery(id, { skip: !id });

  useEffect(() => {
    if (itemDetailData?.success) {
      setUserData(itemDetailData.data.ShopItem);
      setDisplayimg(itemDetailData.data.ShopItem?.images || []);
    }
  }, [itemDetailData]);

  const [uploadedImages, setUploadedImages] = useState([]);

  const onChangePicture = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.onloadend = () => {
      setUploadedImages([...uploadedImages, reader.result]);
    };

    if (file) {
      reader.readAsDataURL(file);
    }
  };

  const removeImage = (index) => {
    const updatedImages = [...displayimg];
    updatedImages.splice(index, 1);
    setDisplayimg(updatedImages);
  };


  const [selectedCountry, setSelectedCountry] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  const [selectedstateone, setSelectedstateone] = useState("");
  const [searchTermone, setSearchTermone] = useState("");

  const [selectedcity, setSelectedcity] = useState("");
  const [searchTermtwo, setSearchTermtwo] = useState("");
  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  // Function to handle the country selection
  const handleCountryChange = (event) => {
    const { value } = event.target;
    setSelectedCountry(value);
  };

  const handleSearchChangestate = (event) => {
    setSearchTermone(event.target.value);
  };

  const handleSearchChangecity = (event) => {
    setSearchTermtwo(event.target.value);
  };

  // Function to handle the state selection
  const handleCountryChangestate = (event) => {
    const { value } = event.target;
    setSelectedstateone(value);
  };

  // Function to handle the city selection
  const handleCountryChangecity = (event) => {
    const { value } = event.target;
    setSelectedcity(value);
  };
  const [hidefield, setHidefield] = useState(1);
  const [hidestate, setHidestate] = useState(1);
  const [hidecity, setHidecity] = useState(1);

  const [countrydata, SetCountrydata] = useState([]);
  const [getcountry] = useState();
  const [selectedState] = useState();
  const [getState, setState] = useState([]);
  const [getcity, setGetcity] = useState([]);
  const [statetwo, setStatetwo] = useState(getcountry);
  const [city, setCity] = useState(selectedState);
  const [open, setOpen] = useState(getcountry);

  const { data: citiesData } = useGetWorldCitiesQuery();

  useEffect(() => {
    if (citiesData) {
      SetCountrydata(citiesData);
    }
  }, [citiesData]);

  const country = [...new Set(countrydata.map((item) => item.country))];

  country.sort();

  const handleCountry = (e) => {
    let states = countrydata.filter(
      (state) => state.country === e.target.value
    );
    states = [...new Set(states.map((item) => item.subcountry))];
    states.sort();
    setState(states);
  };

  const handleState = (e) => {
    let cities = countrydata.filter(
      (city) => city.subcountry === e.target.value
    );
    setGetcity(cities);
  };


  console.log("userdataaa", userData)


  if (isloading) {
    return <Loader heightsetting="screenHeight" />;
  }


  return (
    <>
      {selectedImage && <PersonalImage image={selectedImage} />}
      <Container>
        <Row>
          <div className="screenHeight d-flex justify-content-center align-items-center">
            <Col lg={10} md={12} sm={12} xs={12} className="Form-Shadow">
              <Row>
                <Col className="">
                  <div className="arrowback ps-3">
                    <BackArrow back="/SellingSide" black="black" />
                  </div>
                  {/* <div className="pe-3  pb-2"> */}
                  {/* </div> */}
                </Col>
              </Row>
              <div className="p-4">
                <Row className="pt-2 pb-2 px-3">
                  <Col md={3} lg={3} xl={3}>
                    <Form.Label className="custm-lble">Item Name</Form.Label>
                    <Form.Control
                      defaultValue={userData?.itemname}
                      placeholder="Item Name"
                      name="itemname"
                      className="input-style form-control-seller"
                      onChange={(e) => InputChange(e)}
                    />
                  </Col>
                  <Col md={3} lg={3} xl={3}>
                    <Form.Label className="custm-lble">Price</Form.Label>
                    <Form.Control
                      onChange={(e) => InputChange(e)}
                      placeholder="Price"
                      defaultValue={userData?.price}
                      name="price"
                      className="input-style form-control-seller"
                      type="number"
                    />
                  </Col>

                  <Col md={3} lg={3} xl={3}>
                    <Form.Label className="custm-lble">
                      Select Category
                    </Form.Label>
                    <Form.Select
                      onChange={(e) => Handledata(e)}
                      onClick={(e) => FirstCategory(e)}
                      className="input-style form-control-seller"
                      aria-label="Default select example"
                      name="category"
                    >
                      {location.pathname === `/single-item-update/${id}` ? (userData?.category?.length > 0 ? (<option> {userData?.category}</option>) : (<option>Select-Category</option>)) : (<option>Select-Category</option>)}
                      {
                        shopCategory?.map((e) => (

                          <option key={e?._id} value={`${e?._id}.${e?.name}`}>{e?.name}</option>
                        ))
                      }
                    </Form.Select>
                  </Col>

                  <Col md={3} lg={3} xl={3}>
                    <Form.Label className="custm-lble">
                      Select Sub-Category
                    </Form.Label>
                    <Form.Select
                      className="input-style form-control-seller"
                      aria-label="Default select example"
                      name="subCategory"
                      onChange={(e) => InputChange(e)}
                      onClick={(e) => Mydata(e)}
                    >
                      {location.pathname === `/single-item-update/${id}` ? (userData?.subCategory?.length > 0 ? (<option> {userData?.subCategory}</option>) : (<option>Select Sub-Category</option>)) : (<option>Select Sub-Category</option>)}
                      {/* <option>Select Sub-Category</option> */}
                      {
                        shopCategorytwo?.map((e) => (

                          <option key={e?._id} value={e?._id}>{e?.name}</option>
                        ))

                      }

                    </Form.Select>
                  </Col>
                </Row>

                <Row className="pt-2 pb-2  px-3">
                  <Col md={3} lg={3} xl={3}>
                    <Form.Label className="custm-lble">
                      Total Quantity
                    </Form.Label>
                    <Form.Control
                      onChange={(e) => InputChange(e)}
                      placeholder="Quantity"
                      defaultValue={userData?.quantity}
                      name="quantity"
                      className="input-style form-control-seller"
                      type="number"
                    />
                  </Col>

                  <div className="col-md-3">
                    <label
                      htmlFor="inputPassword4"
                      placeholder="First name"
                      className="form-label labelSize"
                    >
                      Country*
                    </label>
                    <div className="blood-type input-style">
                      <div className="d-flex">
                        <div className="w-100">
                          <input
                            type="search"
                            value={searchTerm}
                            onChange={handleSearchChange}
                            placeholder="Search country here...."
                            className="w-100 search-input"
                            onClick={() => setHidefield(0)}
                          />
                        </div>
                        <div>
                          <span>
                            <SearchIcon className="search-icon-fs" />
                          </span>
                        </div>
                      </div>

                      <select
                        onClick={() => setHidefield(1)}
                        value={selectedCountry}
                        onChange={(e) => {
                          InputChange(e);
                          handleCountryChange(e);
                          handleCountry(e);
                        }}
                        className="b-radius selectSize w-100"
                        name="country"
                      >

                        {hidefield && <option>{userData?.country}</option>}

                        {country
                          .filter((country) =>
                            country
                              .toLowerCase()
                              .includes(searchTerm.toLowerCase())
                          )
                          .map((country, index) => (
                            <option key={country} value={getcountry}>
                              {country}
                            </option>
                          ))}
                      </select>

                    </div>
                  </div>

                  <div className="col-md-3">
                    <label
                      htmlFor="inputPassword4"
                      placeholder="First name"
                      className="form-label labelSize"
                    >
                      State*
                    </label>
                    <div className="blood-type input-style">
                      <div className="d-flex">
                        <div className="w-100">
                          <input
                            type="search"
                            value={searchTermone}
                            onChange={handleSearchChangestate}
                            placeholder="Search state here...."
                            className="w-100 search-input"
                            onClick={() => setHidestate(0)}
                          />
                        </div>
                        <div>
                          <span>
                            <SearchIcon className="search-icon-fs" />
                          </span>
                        </div>
                      </div>

                      <select
                        onClick={() => setHidestate(1)}
                        className="b-radius selectSize w-100"
                        value={selectedstateone}
                        aria-label="Default select example "
                        name="state"
                        onChange={(e) => {
                          InputChange(e);
                          handleState(e);
                          handleCountryChangestate(e);
                        }}
                      >
                        {hidestate && <option>{userData?.state}</option>}
                        {/* <option>
                            {Open === undefined
                              ? "Select Country First"
                              : "select state"}
                          </option> */}

                        {getState
                          .filter((country) =>
                            country
                              .toLowerCase()
                              .includes(searchTermone.toLowerCase())
                          )
                          .map((country) => (
                            <option key={country} value={selectedState}>
                              {country}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-3 ">
                    <label
                      htmlFor="inputPassword4"
                      placeholder="First name"
                      className="form-label labelSize"
                    >
                      City
                    </label>
                    <div className="blood-type input-style">
                      <div className="d-flex">
                        <div className="w-100">
                          <input
                            type="search"
                            value={searchTermtwo}
                            onChange={handleSearchChangecity}
                            placeholder="Search city here...."
                            className="w-100 search-input"
                            onClick={() => setHidecity(0)}
                          />
                        </div>
                        <div>
                          <span>
                            <SearchIcon className="search-icon-fs" />
                          </span>
                        </div>
                      </div>

                      <select
                        onClick={() => setHidecity(1)}
                        value={selectedcity}
                        className="b-radius selectSize w-100"
                        aria-label="Default select example"
                        name="city"
                        onChange={(e) => {
                          handleCountryChangecity(e); InputChange(e)
                        }}
                      >
                        {/* <option>
                              {city === undefined
                                ? "Select State First"
                                : "Select City"}
                            </option> */}

                        {hidecity && <option>{userData?.city}</option>}
                        {getcity
                          .filter((country) =>
                            country.name
                              .toLowerCase()
                              .includes(searchTermtwo.toLowerCase())
                          )
                          .map((country) => (
                            <option key={country.name}>{country.name}</option>
                          ))}
                      </select>
                    </div>
                  </div>
                </Row>

                <Row className="pt-2 pb-2  px-3">
                  <Col className=" mt-3" md={3} lg={3} xl={3}>
                    <Form.Label className="custm-lble">
                      Unit of Measurement{" "}
                    </Form.Label>
                    <Form.Select
                      onChange={(e) => InputChange(e)}
                      aria-label="Default select example"
                      name="unitOfMeasurement"

                      className="input-style form-control-seller"
                    // onChange={(e) => {
                    //   handleChange(e);
                    //   inputChange(e);
                    // }}
                    >
                      <option>{userData?.unitOfMeasurement}</option>
                      {Measurementunit.map((e) => (

                        <option>{e.name}</option>
                      ))}
                    </Form.Select>
                  </Col>

                  <Col md={3} lg={3} xl={3} className="mt-3">
                    <Form.Label className="custm-lble">Currency </Form.Label>
                    <Form.Select
                      onChange={(e) => InputChange(e)}
                      aria-label="Default select example"
                      name="currency"
                      className="input-style form-control-seller"
                    // onChange={(e) => {
                    //   handleChange(e);
                    //   inputChange(e);
                    // }}
                    >
                      <option>{userData?.currency}</option>
                      {currencies.map((e) => (
                        <option>
                          {e.abbreviation} {e.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Col>
                </Row>

                <div className="ps-3 pe-3 pt-4">
                  <Form.Label className="custm-lble">Description</Form.Label>
                  <Form.Control
                    onChange={(e) => InputChange(e)}
                    as="textarea"
                    rows={5}
                    name="description"
                    defaultValue={userData?.description}
                    className="input-style"
                  />
                </div>
                <div className="d-flex justify-content-between pt-2">

                  <Col>
                    <Row>
                      <Col lg="9" className="me-auto">
                        <Row>
                          <Col lg={2} className=" mt-2 pt-4 ps-4">
                            <Card
                              style={{
                                width: "6rem",
                                height: "6rem",
                                position: "relative", // ✅ to position loader
                              }}
                              {...getRootProps()}
                              className="dropzone"
                            >
                              {/* Show loader if uploading */}
                              {isUploading ? (
                                <div
                                  style={{
                                    position: "absolute",
                                    inset: 0,
                                    background: "rgba(255,255,255,0.7)",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    flexDirection: "column",
                                    borderRadius: "0.5rem",
                                  }}
                                >
                                  <div
                                    className="spinner-border text-primary"
                                    style={{ width: "1.5rem", height: "1.5rem" }}
                                    role="status"
                                  ></div>
                                  <small className="mt-1">{uploadProgress}%</small>
                                </div>
                              ) : (
                                <>
                                  <Card.Img className="imet-fit" src={images.AddImage} />
                                  <Card.Body>
                                    <input
                                      type="file"
                                      id="file"
                                      style={{ display: "none" }}
                                      {...getInputProps()}
                                      multiple
                                      autoComplete="off"
                                    />
                                  </Card.Body>
                                </>
                              )}
                            </Card>
                          </Col>

                          {displayimg?.length > 0 && (
                            <Col lg={7} className=" mt-1 pt-4 ps-4 d-flex">
                              {displayimg.map((image, index) => (
                                <Card
                                  key={index}
                                  className="me-2 mt-1"
                                  style={{
                                    width: "6rem",
                                    height: "6rem",
                                    border: "2px solid",
                                    position: "relative",
                                  }}
                                >
                                  <Card.Img
                                    className="imet-fit upload-img mt-0"
                                    src={getAsset(image)}
                                    alt=""
                                    crossOrigin="anonymous"
                                  />
                                  <div
                                    className="close-btnone"
                                    onClick={() => removeImage(index)}
                                  >
                                    <ClearIcon />
                                  </div>
                                </Card>
                              ))}
                            </Col>
                          )}
                        </Row>
                      </Col>
                    </Row>
                  </Col>

                  <div className="d-flex align-items-end pb-3 pe-3">
                    <div className="btns">
                      <button
                        className="btn1"
                        onClick={() => navigate(location.pathname === `/single-item-update/${id}` ? `/singleitem-show/${id}` : `/SellingSide`)}
                      // onClick={() => {
                      //   location.pathname === `/single-item-update/${id}` ? navigate("/BuyingSide") :
                      //     navigate("/SellingSide")
                      // }}
                      >
                        Cancel
                      </button>
                      <Button className="btn2 p-1" variant="primary" onClick={(e) => userDatahandler(e)}>

                        Update
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default UpdateSingleAdd;
